const ZIGGU_GREEN = Object.freeze({
  rgb_50: '238 247 237',
  rgb_100: '184 213 200',
  rgb_200: '130 178 164',
  rgb_300: '75 143 128',
  rgb_400: '21 109 91',
  rgb_500: '9 101 83',
  rgb_600: '7 82 70',
  rgb_700: '6 63 57',
  rgb_800: '4 44 43',
  rgb_900: '2 26 30',
  rgb_950: '1 13 15',
  hex_50: '#eef7ed',
  hex_100: '#b8d5c8',
  hex_200: '#82b2a4',
  hex_300: '#4b8f80',
  hex_400: '#156d5b',
  hex_500: '#096553',
  hex_600: '#075246',
  hex_700: '#063f39',
  hex_800: '#042c2b',
  hex_900: '#021a1e',
  hex_950: '#010d0f',
  h: 168,
  s: 84,
  l: 22,
});

export default ZIGGU_GREEN;
